
import { supabase } from '@/integrations/supabase/client';
import { useAuthStore } from '../authStore';
import { toast } from '@/hooks/use-toast';
import { ChatState } from './types';
import { ChatMessage } from '@/types/chat';

export const createRealtimeOperations = (set, get: () => ChatState) => ({
  setupRealtimeSubscription: (storeId: string) => {
    const channel = supabase
      .channel('chat-updates')
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'chat_messages',
        filter: `store_id=eq.${storeId}`
      }, async (payload) => {
        await get().fetchMessages(storeId);
        
        // Show toast notification for new messages if not from current user
        if (payload.eventType === 'INSERT') {
          const newMessage = payload.new as ChatMessage;
          const currentUser = useAuthStore.getState().user;
          
          if (currentUser && newMessage.sender_id !== currentUser.id) {
            toast({
              title: `New message from ${newMessage.sender_name}`,
              description: newMessage.message_type === 'text' 
                ? newMessage.content.substring(0, 50) + (newMessage.content.length > 50 ? '...' : '')
                : `Sent a ${newMessage.message_type}`,
              duration: 3000,
            });
            
            // Update unread count if not in chat view
            if (!document.hasFocus() || window.location.pathname !== '/dashboard/chat') {
              if (get().getUnreadCount) {
                await get().getUnreadCount(storeId);
              }
            }
          }
        }
      })
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'chat_message_reactions'
      }, async () => {
        await get().fetchMessages(storeId);
      })
      .subscribe();
    
    // Return unsubscribe function
    return () => {
      supabase.removeChannel(channel);
    };
  },
});
